export default __webpack_public_path__ + "static/media/ngr-strong.e7201e5f.png";